import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { InputText } from 'triider-components';
import { validateUserFields } from 'utils/userValidation';
import iconEmail from 'assets/img/email-icon.svg';
import { Creators as UiCreators } from 'store/ducks/ui';
import { Creators as AuthCreators } from 'store/ducks/auth';

import {
  Container, BoxRecovery, Icon, Title, Desc, StyledButtonTriider,
} from './styles';

class RecoveryPass extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      errors: {},
    };
  }

  setFields = ({ target }) => {
    const { name, value } = target;

    this.setState({ [name]: value });
  }

  validateField = ({ target }) => {
    const { name, value } = target;

    const message = validateUserFields(name, value);

    const { errors: oldErrors } = this.state;

    const errors = {
      ...oldErrors,
      [name]: message,
    };

    this.setState({ errors });
  }

  send = (e) => {
    e.preventDefault();

    const { email } = this.state;

    const errors = {
      email: validateUserFields('email', email),
    };

    if (!Object.values(errors).some(e => !!e)) {
      const { _forgotPasswordSendEmail } = this.props;
      _forgotPasswordSendEmail({ email });
    } else {
      this.setState({ errors });
    }
  }

  render() {
    const { email, errors } = this.state;
    const { isLoading } = this.props;

    const buttonDisabled = !email || Object.values(errors).some(e => !!e);

    return (
      <Container>
        <Helmet title="Triider - Recuperar senha" />
        <BoxRecovery>
          <Icon />
          <Title>Esqueci minha senha</Title>
          <Desc>Insira o e-mail da sua conta para enviarmos uma novas senha!</Desc>
          <form onSubmit={this.send}>
            <InputText
              placeholder="E-mail:"
              type="email"
              name="email"
              value={email}
              error={errors.email}
              onChange={this.setFields}
              onBlur={this.validateField}
              iconRight={iconEmail}
            />
            <StyledButtonTriider
              type="submit"
              size="fullBlock"
              disabled={buttonDisabled}
              isLoading={isLoading}
            >
              Enviar
            </StyledButtonTriider>
          </form>
        </BoxRecovery>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  loadingVisible: state.ui.loaders.includes('RECOVERY_PASSWORD'),
});

const mapDispatchToProps = {
  _forgotPasswordSendEmail: AuthCreators.forgotPasswordSendEmailrequest,

};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RecoveryPass);
